import type { ToolDefinition } from '../types';
import { RelightPanel } from './panel';
import {
  DEFAULT_RELIGHT_PARAMS,
  normalizeRelightParams,
  type RelightParams,
} from './types';
import { buildRelightImageNodeData } from './config';

export const relightTool: ToolDefinition<RelightParams> = {
  id: 'relight',
  label: 'tool.relight.name',
  defaultParams: DEFAULT_RELIGHT_PARAMS,
  normalize: normalizeRelightParams,
  Panel: ({ params, onChange }) => <RelightPanel params={params} onChange={onChange} />,
  onRun: ({ params, now, sourceNodeId }) => ({
    createNode: {
      type: 'image',
      data: buildRelightImageNodeData({ params, now, sourceToolNodeId: sourceNodeId }),
    },
    connectFromSource: true,
    autoRun: true,
  }),
};

export type { RelightParams };
export { DEFAULT_RELIGHT_PARAMS, normalizeRelightParams };


